module.exports = __webpack_public_path__ + "ci.svg?78df372643be0e307ba5f7830e47451c";